var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarGraduate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 3.04883H2.29049C1.85391 3.04883 1.5 3.40274 1.5 3.83932V20.6826C1.5 21.1191 1.85391 21.4731 2.29049 21.4731H22.1666C22.6032 21.4731 22.9571 21.1191 22.9571 20.6826V3.83932C22.9571 3.40274 22.6032 3.04883 22.1666 3.04883Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36936 1H6.78756C6.35099 1 5.99707 1.35391 5.99707 1.79049V5.09474C5.99707 5.53132 6.35099 5.88523 6.78756 5.88523H7.36936C7.80594 5.88523 8.15985 5.53132 8.15985 5.09474V1.79049C8.15985 1.35391 7.80594 1 7.36936 1Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6701 1H17.0883C16.6518 1 16.2979 1.35391 16.2979 1.79049V5.09474C16.2979 5.53132 16.6518 5.88523 17.0883 5.88523H17.6701C18.1067 5.88523 18.4606 5.53132 18.4606 5.09474V1.79049C18.4606 1.35391 18.1067 1 17.6701 1Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73029 9.42773H5.39254C4.95597 9.42773 4.60205 9.78165 4.60205 10.2182V12.556C4.60205 12.9925 4.95597 13.3465 5.39254 13.3465H7.73029C8.16686 13.3465 8.52078 12.9925 8.52078 12.556V10.2182C8.52078 9.78165 8.16686 9.42773 7.73029 9.42773Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3978 9.42773H11.06C10.6234 9.42773 10.2695 9.78165 10.2695 10.2182V12.556C10.2695 12.9925 10.6234 13.3465 11.06 13.3465H13.3978C13.8343 13.3465 14.1883 12.9925 14.1883 12.556V10.2182C14.1883 9.78165 13.8343 9.42773 13.3978 9.42773Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0648 9.42773H16.727C16.2904 9.42773 15.9365 9.78165 15.9365 10.2182V12.556C15.9365 12.9925 16.2904 13.3465 16.727 13.3465H19.0648C19.5013 13.3465 19.8552 12.9925 19.8552 12.556V10.2182C19.8552 9.78165 19.5013 9.42773 19.0648 9.42773Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73029 14.8174H5.39254C4.95597 14.8174 4.60205 15.1713 4.60205 15.6079V17.9456C4.60205 18.3822 4.95597 18.7361 5.39254 18.7361H7.73029C8.16686 18.7361 8.52078 18.3822 8.52078 17.9456V15.6079C8.52078 15.1713 8.16686 14.8174 7.73029 14.8174Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3978 14.8174H11.06C10.6234 14.8174 10.2695 15.1713 10.2695 15.6079V17.9456C10.2695 18.3822 10.6234 18.7361 11.06 18.7361H13.3978C13.8343 18.7361 14.1883 18.3822 14.1883 17.9456V15.6079C14.1883 15.1713 13.8343 14.8174 13.3978 14.8174Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0648 14.8174H16.727C16.2904 14.8174 15.9365 15.1713 15.9365 15.6079V17.9456C15.9365 18.3822 16.2904 18.7361 16.727 18.7361H19.0648C19.5013 18.7361 19.8552 18.3822 19.8552 17.9456V15.6079C19.8552 15.1713 19.5013 14.8174 19.0648 14.8174Z",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.45508H22.9571",
    stroke: "#2A5A16",
    strokeWidth: 0.991334,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.444 18.9775V22.7714L17.4544 25L12.4648 22.7714V18.9775",
    fill: "#EBFFB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.444 18.9775V22.7714L17.4544 25L12.4648 22.7714V18.9775",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6653 21.3063C24.1309 20.003 24.2885 18.148 24.4213 18.0938Z",
    fill: "#EBFFB3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6653 21.3063C24.1309 20.003 24.2885 18.148 24.4213 18.0938",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6712 22.2906C24.9852 22.2906 25.2398 22.036 25.2398 21.7219C25.2398 21.4079 24.9852 21.1533 24.6712 21.1533C24.3571 21.1533 24.1025 21.4079 24.1025 21.7219C24.1025 22.036 24.3571 22.2906 24.6712 22.2906Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4542 21.3644L10.4873 18.2525L17.4542 15.1406L24.421 18.2525L17.4542 21.3644Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGraduate);
export default __webpack_public_path__ + "static/media/calendar_graduate.00cbed187d474f2dbb8c480e9f96a80b.svg";
export { ForwardRef as ReactComponent };